<template>
    <el-row>
        <el-form :model="searchcarForm" :rules="rules" @onSelectInfo="onSelectInfo"
                 addAction="/searchcar/saveSearchcar.action"
                 editAction="/searchcar/editSearchcar.action"
                 label-width="150px"
                 ref="searchcarForm" selectAction="/searchcar/selectMySearchcarDetail.action"
                 style="width:70%" v-form>
            <el-form-item label="求购用户" prop="publishPhone">
                <el-input placeholder="请输入已注册的11位手机号" v-model="searchcarForm.publishPhone"></el-input>
            </el-form-item>

            <el-form-item label="选择车系"  prop="seriesId" :rules="[{ required: !searchcarForm.seriesId, message: '车系不能为空'}]">
                <brand-and-series-categories-select  brandPlaceholder="品牌（单选）" seriesPlaceholder="车系（单选）" categoriesPlaceholder="车型可选" :categoriesMultiple="false" ref="brand-and-series-select" @onChanged="carCategoryChange"></brand-and-series-categories-select>
            </el-form-item>

            <el-form-item label="车源地" prop="searchAddress">
                <p v-if="!searchcarForm.searchAddress">全国</p>
                <el-select multiple v-model="searchcarForm.searchAddress" placeholder="请选择车源地">
                    <el-option  v-for="item in provinces" :label="item.value" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="联系电话" prop="phone">
                <el-input placeholder="请输入联系手机号" v-model="searchcarForm.phone"></el-input>
            </el-form-item>

            <el-form-item label="其他内容" prop="content">
                <quill-editor v-model="searchcarForm.content" ref="myQuillEditor" :options="editorOption" style="width:100%;height: 200pt;">
                </quill-editor>
            </el-form-item>

            <el-form-item style="margin-top:100px;">
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import { quillEditor } from 'vue-quill-editor'
import { quillRedefine } from 'vue-quill-editor-upload'
let provinces = require('@/framework/data/provices.json')

export default {
  extends: BasicPager,
  name: 'saveSearchcar',
  data () {
    return {
      provinces: provinces,
      searchcarForm: {
        id: null,
        content: null,
        brandId: null,
        seriesId: null,
        categoryId: null,
        brand: null,
        series: null,
        category: null
      },
      rules: {
        publishPhone: [
          { required: true, message: '请输入注册手机号', trigger: 'blur' }, { max: 11, message: '电话号码不能大于11位！' }
        ],
        phone: [
          { required: true, message: '请输入联系手机号', trigger: 'blur' }, { max: 11, message: '电话号码不能大于11位！' }
        ]
      }
    }
  },
  components: {
    BrandAndSeriesCategoriesSelect,
    quillEditor,
    quillRedefine
  },
  created () {
    this.searchcarForm.id = this.$route.params.id
    this.editorOption = quillRedefine({
      toolOptions: [],
      // 以下所有设置都和vue-quill-editor本身所对应
      placeholder: '请输入内容', // 可选参数 富文本框内的提示语
      theme: '', // 可选参数 富文本编辑器的风格
      handlers: {} // 可选参数 重定义的事件，比如link等事件
    }
    )
  },
  methods: {
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {
      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
      }
      if (dataInfo.datas) {
        this.searchcarForm.brand = dataInfo.datas.brand
        this.searchcarForm.series = dataInfo.datas.series
        this.searchcarForm.category = dataInfo.datas.category
        this.searchcarForm.brandId = dataInfo.datas.brandId
        this.searchcarForm.seriesId = dataInfo.datas.seriesId
        this.searchcarForm.categoryId = dataInfo.datas.categoryId
      }
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      // 品牌车系车型
      this.searchcarForm.brandId = brandInfo.id
      this.searchcarForm.brand = brandInfo.name
      if (seriesInfo) {
        this.searchcarForm.seriesId = seriesInfo.id
        this.searchcarForm.series = seriesInfo.name
      } else {
        this.searchcarForm.seriesId = null
        this.searchcarForm.series = null
      }

      if (categoriesInfo) {
        this.searchcarForm.categoryId = categoriesInfo.id
        this.searchcarForm.category = categoriesInfo.name
      } else {
        this.searchcarForm.categoryId = null
        this.searchcarForm.category = null
      }
    }
  }
}
</script>

<style scoped>

</style>
